if (__DEV__) {
  require('./components/EngineTasksContainer');
}

import createTestWizard from './pages/create-test-wizard';

export default store => ({
  path: 'tasks',

  getComponent(nextState, cb) {
    import(/* webpackChunkName: "engines" */ './components/EngineTasksContainer')
      .then(loadRoute(cb))
      .catch(errorLoading);
  },

  childRoutes: [createTestWizard].map(r => r(store))
});

function errorLoading(err) {
  console.error('Dynamic page loading failed', err);
}

function loadRoute(cb) {
  return module => cb(null, module.default);
}



// WEBPACK FOOTER //
// ./src/client/plugins/engines/pages/engine-tasks/index.js